import axios from "axios";
import {
  enrollInternshipRoute,
  getEnrolledInternshipRoute,
  submitWorkRoute,
} from "../common/endpoints";

export const enrollInInternships = async (cookies, enrollData) => {
  const { token } = cookies;
  const config = {
    method: "post",
    url: enrollInternshipRoute,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: JSON.stringify(enrollData),
  };

  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const getEnrolledInternships = async (cookies) => {
  const { userID, token } = cookies;
  const config = {
    method: "get",
    url: `${getEnrolledInternshipRoute}?userID=${userID}`,
    headers: { Authorization: `Bearer ${token}` },
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const submitInternshipWork = async (cookies, workData) => {
  const { token } = cookies;
  const config = {
    method: "put",
    url: submitWorkRoute,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: JSON.stringify(workData),
  };

  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
